"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Styles = __importStar(require("../social-share-widget-styles"));
const segments_1 = require("../segments");
const SocialShareButton = ({ theme, postUrl, item, socialShareIconStyles, widgetType, ctaText }) => {
    const Icon = item === null || item === void 0 ? void 0 : item.icon;
    const [socialShareWidget, setSocialShareWidget] = (0, react_1.useState)('');
    const getSegmentData = () => {
        return {
            widget_type: widgetType,
            cta_text: ctaText,
            name: socialShareWidget
        };
    };
    (0, react_1.useEffect)(() => {
        if (socialShareWidget) {
            (0, segments_1.triggeredSegment)('tap_btn_engage', Object.assign({}, getSegmentData()));
        }
    }, [socialShareWidget]);
    const handleClick = () => {
        setSocialShareWidget(item.label || '');
        item === null || item === void 0 ? void 0 : item.onClick({ postUrl });
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Styles.ButtonWrapper, { onClick: handleClick, theme: theme },
            react_1.default.createElement(Icon, Object.assign({}, socialShareIconStyles, { theme: theme })),
            react_1.default.createElement(Styles.TextStyle, { styles: item === null || item === void 0 ? void 0 : item.style, theme: theme }, item === null || item === void 0 ? void 0 : item.label)),
        react_1.default.createElement(Styles.BottomBorder, { theme: theme })));
};
exports.default = SocialShareButton;
//# sourceMappingURL=SocialShareButton.js.map